import * as React from 'react';

import type {LocationObject, SelectComponentValue} from 'nutshell-core/types';

import {Select} from 'shells/select/select';

import {LocationFound} from '../../core/search/location-found';
// @ts-expect-error
import getClassesMixin from '../../mixins/get-classes';

// @ts-expect-error
import {LocationAjaxSearch} from './location-ajax-search';

const selectValues = [
    {id: '5', name: '5mi (8km)'},
    {id: '25', name: '25mi (40km)'},
    {id: '50', name: '50mi (80km)'},
    {id: '100', name: '100mi (160km)'},
    {id: '250', name: '250mi (400km)'},
];

// @ts-expect-error
const MapboxConfig = window.MapboxConfig;

type LocationRadiusSearchProps = {
    onLocationChange: (...args: any) => any;
    onRadiusChange: (...args: any) => any;
    locationString?: string;
    radius?: number;
};

export class LocationRadiusSearch extends React.Component<LocationRadiusSearchProps> {
    getClasses = getClassesMixin;

    static defaultProps = {
        radius: 5,
    };

    render() {
        const classes = this.getClasses('ui-location-radius-search');

        return (
            <div className={classes}>
                <div className='ui-location-radius-search__radius'>
                    <Select
                        value={selectValues.find((val) => val.id === String(this.props.radius))}
                        selectValues={selectValues}
                        onChange={this.handlePostalCodeChange}
                    />
                    <label className='ui-location-radius-search__label'>of</label>
                    <div className='ui-location-search'>
                        <LocationAjaxSearch
                            onSelect={this.handleLocationChange}
                            accessToken={MapboxConfig.apiKey}
                        />
                        {this.props.locationString ? (
                            <LocationFound
                                locationString={this.props.locationString}
                                onClear={this.handleLocationClear}
                            />
                        ) : undefined}
                    </div>
                </div>
            </div>
        );
    }

    handleLocationClear = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onLocationChange(undefined);
    };

    handlePostalCodeChange = (postalCode: SelectComponentValue) => {
        this.props.onRadiusChange(postalCode.id);
    };

    handleLocationChange = (e: React.SyntheticEvent, location: LocationObject) => {
        this.props.onLocationChange(location);
    };
}
